document.addEventListener("DOMContentLoaded", function() {
  const textArray = [
    "Grippe", 
    "Kopfschmerzen", 
    "Defibrillator", 
    "Verbandskasten", 
    "Blutdruckmessgerät", 
    "Stethoskop"
  ];
  
  // WICHTIG: Wir suchen jetzt ALLE Suchfelder, nicht nur das erste!
  const searchInputs = document.querySelectorAll('input[name="q"]');
  
  if (searchInputs.length > 0) {
    let arrayIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function type() {
      // Sicherheits-Check
      if (!textArray[arrayIndex]) { arrayIndex = 0; }
      
      const currentWord = textArray[arrayIndex];
      let typeSpeed = 100;

      if (isDeleting) {
        typeSpeed = 40; 
        charIndex--;
      } else {
        typeSpeed = 80 + Math.random() * 50; 
        charIndex++;
      }

      // Grenzen setzen
      if (charIndex < 0) charIndex = 0;
      if (charIndex > currentWord.length) charIndex = currentWord.length;

      // Das Wort in ALLE gefundenen Suchfelder schreiben
      searchInputs.forEach(input => {
          input.setAttribute('placeholder', currentWord.substring(0, charIndex));
      });

      // Logik für Wechsel
      if (!isDeleting && charIndex === currentWord.length) {
        typeSpeed = 2000;
        isDeleting = true;
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        arrayIndex++;
        if (arrayIndex >= textArray.length) arrayIndex = 0;
        typeSpeed = 500;
      }

      setTimeout(type, typeSpeed);
    }

    setTimeout(type, 1000);
  }
});